import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
export class STVPlayerProcessor extends AbstractTagClass {
    constructor(argument) {
        super({
            ...argument,
            name: 'STVPlayerProcessor'
        });
    }
}
